export const CHECKOUT_URL = 'https://ingles-para-viajar-2026.impultienda.ar/checkout'

/* Todos los botones e imágenes llevan a la sección de compra */
export const OFFER_ANCHOR = '#oferta'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/obR1qC9DHzLE3FW2bATJLV/Mega_Pack_Ingles_para_Viajar_2026.png'

export const PRODUCT_NAME = 'MEGA PACK INGLÉS PARA VIAJAR 2026'

export const PRICE = '$19.990'

export const BONUS_TOTAL = '$39.950'

/* 1. PROBLEMA */
export const problems = [
  {
    title: 'NO ENTENDÉS CUANDO TE HABLAN',
    desc: 'Pensás en llegar a un aeropuerto, pasar migraciones o hablar con la recepción de un hotel y te preocupa quedarte en blanco porque no entendés lo que te están diciendo.',
  },
  {
    title: 'NO SABÉS QUÉ FRASES APRENDER',
    desc: 'Buscás videos, aplicaciones y traducciones, pero encontrás miles de palabras y reglas gramaticales sin saber cuáles vas a necesitar realmente durante tu viaje.',
  },
  {
    title: 'TE DA MIEDO COMUNICARTE',
    desc: 'Querés pedir comida, consultar precios, tomar un transporte o solicitar ayuda, pero te preocupa pronunciar mal o no poder responder una pregunta sencilla.',
  },
  {
    title: 'SEGUÍS POSTERGANDO',
    desc: 'Querés aprender inglés antes de viajar, pero pasan las semanas y seguís sin encontrar un método organizado que te enseñe lo esencial de manera práctica.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    title: 'INGLÉS ESENCIAL DESDE CERO PARA VIAJEROS',
    desc: 'Aprendé saludos, presentaciones, vocabulario básico, preguntas frecuentes, números, horarios, expresiones de cortesía y las estructuras fundamentales para comenzar a comunicarte en inglés durante tus viajes.',
  },
  {
    title: 'AEROPUERTOS, MIGRACIONES Y VUELOS',
    desc: 'Aprendé a realizar el check-in, presentar documentación, responder preguntas de migraciones, encontrar puertas de embarque, comprender anuncios, gestionar conexiones y resolver problemas con vuelos o equipaje.',
  },
  {
    title: 'HOTELES Y ALOJAMIENTOS',
    desc: 'Aprendé a realizar reservas, registrarte en hoteles, solicitar habitaciones, consultar servicios, pedir ayuda, comunicar problemas, comprender indicaciones y realizar el check-out sin depender constantemente de un traductor.',
  },
  {
    title: 'RESTAURANTES, COMPRAS Y PAGOS',
    desc: 'Aprendé a pedir comida, interpretar menús, consultar ingredientes, solicitar la cuenta, preguntar precios, comprar ropa, elegir talles, utilizar medios de pago y resolver situaciones habituales en comercios.',
  },
  {
    title: 'TRANSPORTE, TURISMO E INDICACIONES',
    desc: 'Aprendé a utilizar taxis, colectivos, trenes y otros transportes, preguntar direcciones, comprender indicaciones, comprar entradas, reservar excursiones y comunicarte durante tus recorridos turísticos.',
  },
  {
    title: 'EMERGENCIAS Y CONVERSACIONES REALES',
    desc: 'Aprendé expresiones para pedir ayuda, comunicar problemas de salud, explicar pérdidas de documentos, realizar reclamos, comprender preguntas frecuentes y mantener conversaciones prácticas durante tus viajes.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    title: '300 FRASES INDISPENSABLES PARA VIAJAR™',
    desc: 'Una colección de 300 expresiones esenciales en inglés y español para utilizar en aeropuertos, hoteles, restaurantes, compras, transporte, turismo, emergencias y conversaciones cotidianas.',
    value: '$7.990',
  },
  {
    title: 'PRONUNCIACIÓN FÁCIL PARA HISPANOHABLANTES™',
    desc: 'Una guía práctica para comprender los sonidos del inglés, mejorar la pronunciación de palabras frecuentes y practicar frases esenciales con explicaciones adaptadas a personas que hablan español.',
    value: '$5.990',
  },
  {
    title: '50 DIÁLOGOS REALES DE VIAJE™',
    desc: '50 conversaciones prácticas con traducción al español para entrenar preguntas, respuestas y situaciones habituales en aeropuertos, migraciones, hoteles, restaurantes, comercios y emergencias.',
    value: '$6.990',
  },
  {
    title: 'GUÍA DE BOLSILLO IMPRIMIBLE™',
    desc: 'Una guía rápida para guardar en el celular o imprimir, con frases esenciales, preguntas frecuentes, vocabulario de viaje, expresiones de emergencia y espacios para información importante.',
    value: '$8.990',
  },
  {
    title: 'PLAN INTENSIVO DE INGLÉS PARA VIAJAR EN 15 DÍAS™',
    desc: 'Un programa de entrenamiento diario con vocabulario, diálogos, ejercicios, pronunciación, simulaciones y evaluaciones para organizar tu aprendizaje antes de viajar.',
    value: '$9.990',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    title: 'MENOS MIEDO AL COMUNICARTE',
    desc: 'Dejá de preocuparte por no saber qué responder y empezá a reconocer las preguntas y expresiones más utilizadas durante un viaje internacional.',
  },
  {
    title: 'MÁS SEGURIDAD EN CADA SITUACIÓN',
    desc: 'Aprendé a comunicarte en aeropuertos, migraciones, hoteles, restaurantes, comercios y transportes con frases prácticas y explicaciones organizadas.',
  },
  {
    title: 'COMPRENDÉ LO QUE TE ESTÁN DICIENDO',
    desc: 'Empezá a identificar preguntas habituales, comprender indicaciones y preparar respuestas para situaciones que podrías vivir durante tus vacaciones.',
  },
  {
    title: 'MÁS INDEPENDENCIA PARA VIAJAR',
    desc: 'Construí una base de inglés que te permita desenvolverte con mayor autonomía, pedir ayuda cuando la necesites y disfrutar tus viajes con más confianza.',
  },
]

/* 5. TESTIMONIOS */
export const testimonials = [
  {
    label: 'TESTIMONIO 1 — APRENDER DESDE CERO',
    quote:
      'Nunca había estudiado inglés y en marzo viajaba a Miami a visitar a mi hija. Empecé con el Tomo 1 sin saber ni los números, y en pocas semanas ya podía saludar, presentarme y preguntar horarios. En el viaje pedí indicaciones yo sola en el shopping y me sentí orgullosísima. Todo está explicado en español y paso a paso.',
    author: 'Graciela Ferreyra',
    detail: '58 años · Córdoba, Argentina',
  },
  {
    label: 'TESTIMONIO 2 — AEROPUERTOS Y MIGRACIONES',
    quote:
      'Lo que más miedo me daba era migraciones en Nueva York. Practiqué con el tomo de aeropuertos las preguntas típicas: motivo del viaje, cuántos días me quedaba, dónde me hospedaba. Cuando el oficial me preguntó, entendí todo y respondí sin trabarme. También usé las frases para la conexión en Houston cuando cambiaron la puerta de embarque.',
    author: 'Martín Quiroga',
    detail: '39 años · Rosario, Argentina',
  },
  {
    label: 'TESTIMONIO 3 — HOTELES Y RESTAURANTES',
    quote:
      'En Londres el hotel nos dio una habitación con una sola cama y pude explicarlo y pedir el cambio con las frases del Tomo 3. Soy celíaca y el tomo de restaurantes me enseñó a preguntar por ingredientes y avisar sobre mi dieta. Comí tranquila todo el viaje, sin depender del traductor del celular en cada mesa.',
    author: 'Silvina Ortega',
    detail: '46 años · Mendoza, Argentina',
  },
  {
    label: 'TESTIMONIO 4 — DIÁLOGOS Y PRONUNCIACIÓN',
    quote:
      'Yo leía algo de inglés pero cuando hablaba no me entendían. La guía de pronunciación para hispanohablantes me mostró justo los sonidos que pronunciaba mal. Después practiqué los 50 diálogos en voz alta, como si fueran conversaciones reales. En Toronto pedí un café, compré entradas y charlé con el taxista sin que me pidieran que repitiera.',
    author: 'Diego Peralta',
    detail: '33 años · Buenos Aires, Argentina',
  },
  {
    label: 'TESTIMONIO 5 — PLAN DE 15 DÍAS',
    quote:
      'Me quedaban dos semanas para viajar a Orlando con mi familia y no sabía por dónde empezar. Seguí el plan intensivo de 15 días: media hora por día, con vocabulario, diálogos y simulaciones. Llegué sabiendo qué decir en el check-in, en el hotel y en los parques. Llevé la guía de bolsillo en el celular y me salvó más de una vez.',
    author: 'Carolina Méndez',
    detail: '35 años · La Plata, Argentina',
  },
]

/* 6. FAQ */
export const faqs = [
  { q: '¿Es físico o digital?', a: 'Es un producto 100% digital.' },
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No. El contenido está organizado para comenzar desde cero.',
  },
  {
    q: '¿Qué voy a aprender?',
    a: 'Inglés práctico para aeropuertos, migraciones, hoteles, restaurantes, compras, transporte, turismo, emergencias y conversaciones cotidianas.',
  },
  {
    q: '¿Incluye ejercicios?',
    a: 'Sí. Incluye frases, diálogos, actividades de pronunciación, simulaciones y ejercicios prácticos.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los 5 bonos están incluidos sin costo adicional.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. Realizás un único pago, sin mensualidades.',
  },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. El acceso al contenido digital se entrega después de confirmar la compra.',
  },
  {
    q: '¿Voy a hablar inglés fluido?',
    a: 'El sistema está orientado a desarrollar habilidades prácticas para viajar. La fluidez depende del tiempo de estudio, la práctica y el nivel de cada persona.',
  },
  {
    q: '¿Puedo aprender a mi ritmo?',
    a: 'Sí. Podés estudiar los tomos y practicar las actividades según tu disponibilidad.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Podés comunicarte al correo de soporte indicado al final de esta página.',
  },
]

/* POP-UP DE COMPRAS RECIENTES — ARGENTINA */
export const recentBuyers = [
  { name: 'Mariana Ruiz', city: 'Córdoba', minutes: 2 },
  { name: 'Lucas Fernández', city: 'Rosario', minutes: 4 },
  { name: 'Andrea Molina', city: 'Buenos Aires', minutes: 6 },
  { name: 'Julieta Domínguez', city: 'Mendoza', minutes: 9 },
  { name: 'Ricardo Paz', city: 'La Plata', minutes: 13 },
  { name: 'Camila Ortiz', city: 'Mar del Plata', minutes: 17 },
  { name: 'Verónica Sánchez', city: 'Salta', minutes: 22 },
  { name: 'Pablo Giménez', city: 'San Miguel de Tucumán', minutes: 27 },
  { name: 'Natalia Correa', city: 'Neuquén', minutes: 31 },
  { name: 'Mateo Aguirre', city: 'Santa Fe', minutes: 38 },
]
